import { Box, Grid, Typography } from "@material-ui/core";
import SponsorsCategoryForm from "../sponsorsCategoryForm";

export default function SponsorsCategoryEditPage({ disabled, ...props }) {
  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Sponsors &gt; Edit Sponsors Category
        </Typography>
      </Box>
      <Grid container xs={6}>
        <SponsorsCategoryForm
          description="Edit Category"
          submitBtnTxt="Save Changes"
          upperBtnGroupSize="50%"
          history={props.history}
          disabled={disabled}
        />
      </Grid>
    </>
  );
}
